<template>
  <div class="roll-call-setting">
    <div class="title">
      <span>检录前，请先设定检录范围</span>
      <span style="color: skyblue" @click="goRollCallRecord">赛事检录记录</span>
    </div>
    <van-field style="margin-bottom: 12px" input-align="right" name="radio" label="检录范围类型">
      <template #input>
        <van-radio-group v-model="type" direction="horizontal">
          <van-radio :name="0" icon-size="16px">按赛程</van-radio>
          <van-radio :name="1" icon-size="16px">按日期</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-form ref="setting">
      <div v-if="type === 0">
        <van-field
          readonly
          clickable
          name="picker"
          :value="setting.matchName"
          label="赛事组别"
          placeholder="请选择赛事组别"
          @click="showMatches = true"
          input-align="right"
          :rules="[{ required: true, message: '请选择赛事组别' }]"
        />
        <van-popup v-model="showMatches" position="bottom" round>
          <van-picker
            show-toolbar
            :columns="matchOptions"
            @confirm="onConfirmMatch"
            @cancel="showMatches = false"
          >
            <template #option="item">
              {{ item.group }}
            </template>
          </van-picker>
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="setting.stageName"
          label="阶段"
          placeholder="请选择阶段"
          @click="showStages = true"
          input-align="right"
          :rules="[{ required: true, message: '请选择阶段' }]"
        />
        <van-popup v-model="showStages" position="bottom" round>
          <van-picker
            show-toolbar
            :columns="stageOptions"
            @confirm="onConfirmStage"
            @cancel="showStages = false"
          >
            <template #option="item">
              {{ item.stageName }}
            </template>
          </van-picker>
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="setting.roundName"
          label="组别轮次"
          placeholder="请选择组别轮次"
          @click="showRounds = true"
          input-align="right"
        />
        <van-popup v-model="showRounds" position="bottom" round>
          <van-picker
            show-toolbar
            :columns="roundOptions"
            @confirm="onConfirmRound"
            @cancel="showRounds = false"
          >
            <template #option="item">
              {{ item.label }}
            </template>
          </van-picker>
        </van-popup>
        <van-field
          readonly
          clickable
          name="picker"
          :value="setting.gameName"
          label="检录比赛"
          placeholder="请选择检录比赛"
          @click="showGames = true"
          input-align="right"
        />
        <van-popup v-model="showGames" position="bottom" round>
          <van-picker
            show-toolbar
            :columns="gameOptions"
            @confirm="onConfirmGame"
            @cancel="showGames = false"
          >
            <template #option="item">
              {{ item.homeTeamName }} vs {{ item.awayTeamName }}
            </template>
          </van-picker>
        </van-popup>
      </div>
      <div v-else>
        <van-field
          readonly
          clickable
          name="calendar"
          :value="setting.date"
          label="比赛日"
          placeholder="请选择比赛日"
          @click="showDate = true"
          input-align="right"
          :rules="[{ required: true, message: '请选择组别轮次' }]"
        />
        <van-calendar v-model="showDate" @confirm="onConfirmDate" :min-date="minDate" :max-date="maxDate" />
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="setting.time"
          label="时段"
          placeholder="请选择时段"
          @click="showTime = true"
          input-align="right"
          :rules="[{ required: true, message: '请选择组别轮次' }]"
        />
        <van-popup v-model="showTime" position="bottom">
          <van-picker
            show-toolbar
            :columns="['全天', '上午（12点前）', '中午（12点后）', '晚间（18点后）']"
            @confirm="onConfirmTime"
            @cancel="showTime = false"
          />
        </van-popup>
<!--        <van-field-->
<!--          readonly-->
<!--          clickable-->
<!--          name="datetimePicker"-->
<!--          :value="setting.location"-->
<!--          label="场地"-->
<!--          placeholder="请选择比赛场地"-->
<!--          input-align="right"-->
<!--          :rules="[{ required: true, message: '请选择组别轮次' }]"-->
<!--        />-->
      </div>
    </van-form>
    <van-button type="info" block style="border-radius: 6px; position: fixed; bottom: 12px; width: calc(100vw - 24px);" @click="goRollCall">开始检录</van-button>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Field, RadioGroup, Radio, Form, Picker,
  Popup, Calendar, Button, DatetimePicker, Dialog, Toast
} from "vant";
import {
  adminGetBMMatchStageGameList,
  adminGetBMUnionMatchGameList2,
  adminGetMatchList,
  adminGetMatchStageList,
  createUserInspectionSetting,
  getUserInspectionSetting,
  updateUserInspectionSetting
} from "@/api/match";
Vue.use(Field).use(Radio).use(RadioGroup).use(Form).use(Picker)
  .use(Popup).use(Calendar).use(Button).use(DatetimePicker).use(Dialog).use(Toast)
import { DateUtil } from '@/utils'
export default {
  data() {
    return {
      unionMatchId: '',
      type: 0,
      setting: {
        matchId: '',
        matchName: '',
        stageId: '',
        stageName: '',
        round: '',
        roundName: '',
        gameId: '',
        gameName: '',
        date: '',
        beginDate: '',
        timeInterval: '',
        time: '',
        location: ''
      },
      showMatches: false,
      matchOptions: [],
      showStages: false,
      stageOptions: [],
      showRounds: false,
      roundOptions: [],
      showGames: false,
      gameOptions: [],
      showDate: false,
      showTime: false,
      isGroupGame: '',
      isCreate: true,
      minDate: new Date(2020, 0, 1),
      maxDate: '',
      rounds: []
    }
  },
  created() {
    window.onPlayCardScanResult = result => {
      const { code } = result
      if (/[0-9]+[?]playerId=[0-9]+/.test(code)) {
        this.$router.push(`/match-manage/result/${code}`)
      } else {
        Toast('请扫码正确二维码')
      }
    }
    this.maxDate = new Date(new Date().getTime() + 30 * 24 * 3600 * 1000)
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.adminGetMatchList()
  },
  methods: {
    adminGetBMMatchStageGameList() {
      const params = {
        matchId: this.setting.matchId,
        stageId: this.setting.stageId
      }
      adminGetBMMatchStageGameList(params).then(res => {
        if (res) {
          const { data } = res
          this.rounds = data.rounds || []
        }
      })
    },
    adminGetMatchList() {
      const params = {
        unionMatchId: this.unionMatchId,
        rollCall: 1
      }
      adminGetMatchList(params).then(res => {
        if (res) {
          const { data } = res
          this.matchOptions = data.list
          this.getUserInspectionSetting()
        }
      })
    },
    getUserInspectionSetting() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getUserInspectionSetting(params).then(res => {
        if (res) {
          const { data } = res
          if ('{}' !== JSON.stringify(data)) {
            this.isCreate = false
            Dialog.confirm({
              message: '是否启用上次设定的检录范围？'
            }).then(async () => {
              this.type = data.type
              const setting = JSON.parse(JSON.stringify(this.setting))
              const match = this.matchOptions.find(m => m.id === data.matchId)
              if (match) {
                setting.matchId = data.matchId
                setting.matchName = match.group
              }
              const stageRes = await adminGetMatchStageList({
                matchId: setting.matchId
              })
              const stageData = stageRes.data
              this.stageOptions = stageData.list || []
              const stage = this.stageOptions.find(s => s.id === data.stageId)
              if (stage) {
                setting.stageId = data.stageId
                setting.stageName = stage.stageName
                const roundOptions = []
                for (let i = 1; i <= stage.roundCount; i++) {
                  roundOptions.push({ value: i, label: `第${i}轮`})
                }
                this.roundOptions = roundOptions
                const ro = this.roundOptions.find(r => r.value === data.round)
                if (ro) {
                  setting.round = data.round
                  setting.roundName = ro.label
                }
              }
              if (setting.round) {
                const gameRes = await adminGetBMUnionMatchGameList2({
                  unionMatchId: this.unionMatchId,
                  matchId: setting.matchId,
                  stageId: setting.stageId,
                  round: setting.round,
                  pageSize: 999,
                  pageNum: 1
                })
                this.gameOptions = gameRes.data.list || []
                const game = this.gameOptions.find(g => g.gameId === data.gameId)
                if (game) {
                  setting.gameName = game.homeTeamName + ' vs ' + game.awayTeamName
                }
              }
              setting.beginDate = data.beginDate
              if (setting.beginDate) {
                setting.date = DateUtil.parseDateTime(setting.beginDate, '{y}-{m}-{d}')
              }
              setting.timeInterval = data.timeInterval
              setting.time = ['全天', '上午（12点前）', '中午（12点后）', '晚间（18点后）'].find((a, i) => i === data.timeInterval)
              setting.location = data.location
              this.setting = setting
            })
          }
        }
      })
    },
    adminGetBMUnionMatchGameList2() {
      const params = {
        unionMatchId: this.unionMatchId,
        matchId: this.setting.matchId,
        stageId: this.setting.stageId,
        round: this.setting.round,
        pageSize: 999,
        pageNum: 1
      }
      adminGetBMUnionMatchGameList2(params).then(res => {
        if (res) {
          const { data } = res
          this.gameOptions = data.list
        }
      })
    },
    goRollCallRecord() {
      this.$router.push({ path: `/match-manage/record/${this.unionMatchId}`})
    },
    goRollCall() {
      this.$refs.setting.validate().then(() => {
        const params = {
          unionMatchId: this.unionMatchId
        }
        if (this.type === 0) {
          params.type = 0
          params.matchId = this.setting.matchId
          params.stageId = this.setting.stageId
          params.round = this.setting.round
          params.gameId = this.setting.gameId
        } else {
          params.type = 1
          params.beginDate = this.setting.beginDate
          params.timeInterval = this.setting.timeInterval
        }
        if (this.isCreate) {
          createUserInspectionSetting(params).then(res => {
            if (res) {
              window.location.href = 'banmabang://playercardscan2'
            }
          })
        } else {
          updateUserInspectionSetting(params).then(res => {
            if (res) {
              window.location.href = 'banmabang://playercardscan2'
            }
          })
        }
      })
    },
    onConfirmMatch(match) {
      if (!match) return
      const setting = JSON.parse(JSON.stringify(this.setting))
      setting.matchId = match.id
      setting.matchName = match.group
      setting.stageName = ''
      setting.stageId = ''
      setting.round = ''
      setting.roundName = ''
      setting.gameId = ''
      setting.gameName = ''
      this.setting = setting
      this.stageOptions = []
      this.roundOptions = []
      this.gameOptions = []
      this.adminGetMatchStageList()
      this.showMatches = false
    },
    onConfirmStage(stage) {
      if (!stage) return
      const setting = JSON.parse(JSON.stringify(this.setting))
      setting.stageName = stage.stageName
      setting.stageId = stage.id
      setting.round = ''
      setting.roundName = ''
      setting.gameId = ''
      setting.gameName = ''
      this.setting = setting
      this.gameOptions = []
      const roundOptions = []
      for (let i = 1; i <= stage.roundCount; i++) {
        roundOptions.push({ value: i, label: `第${i}轮`})
      }
      this.roundOptions = roundOptions
      this.showStages = false
    },
    adminGetMatchStageList() {
      const params = {
        matchId: this.setting.matchId
      }
      adminGetMatchStageList(params).then(res => {
        if (res) {
          const { data } = res
          this.stageOptions = data.list || []
        }
      })
    },
    onConfirmRound(round) {
      if (!round) return
      const setting = JSON.parse(JSON.stringify(this.setting))
      setting.roundName = round.label
      setting.round = round.value
      setting.gameId = ''
      setting.gameName = ''
      const r = this.rounds.find(item => item.round === round.value)
      if (r) {
        this.gameOptions = JSON.parse(JSON.stringify(r.games))
      } else {
        this.gameOptions = []
      }
      this.setting = setting
      this.adminGetBMUnionMatchGameList2()
      this.showRounds = false
    },
    onConfirmGame(game) {
      if (!game) return
      const setting = JSON.parse(JSON.stringify(this.setting))
      setting.gameName = game.homeTeamName + ' vs ' + game.awayTeamName
      setting.gameId = game.gameId
      this.setting = setting
      this.showGames = false
    },
    onConfirmDate(date) {
      this.setting.date = DateUtil.parseDateTime(date, '{y}-{m}-{d}')
      this.setting.beginDate = DateUtil.parseDateTime(date, '{y}-{m}-{d}T00:00:00+0800')
      this.showDate = false
    },
    onConfirmTime(value, index) {
      this.setting.time = value
      this.setting.timeInterval = index
      this.showTime = false
    }
  }
}
</script>

<style lang="scss">
.roll-call-setting {
  background-color: #F8F8F8;
  min-height: 100vh;
  padding: 0 12px;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    span {
      font-size: 13px;
    }
  }
}
</style>
